import {defineStore} from 'pinia'
import {useLivewireManager} from "../../Registration/stores/livewireManagerStore";
import {useSettingsManager} from "../../Registration/stores/settingsManagerStore";
import {useBookingStore} from "../../Registration/stores/bookingStore";

const rateLimiterLocalStorageKey = 'captcha.rateLimitUntil'
export const useCaptchaManager = defineStore('captchaManager', {
    state: () => ({
        captcha: {
            image: null,
            fingerprint: null,
        },
        input: null,
        generating: false,
        rateLimitUntil: null,
    }),
    getters: {
        required(state) {
            // Rate limit forces to require captcha
            const isRateLimitActive = Date.now() <= state.rateLimitUntil;
            if (isRateLimitActive) {
                return true;
            }
            const {event} = useSettingsManager();
            const booking = useBookingStore();
            const registrationType = event?.settings?.registration_type;
            if (registrationType === 'open' && booking.data?.status === undefined) {
                return true;
            }
        }
    },
    actions: {
        async initialize() {
            this.initRateLimiter();
            if (this.required) {
                await this.generate();
            }
        },
        initRateLimiter() {
            const rateLimitUntil = localStorage.getItem(rateLimiterLocalStorageKey);
            if(rateLimitUntil) {
                const stillActive = Date.now() < parseInt(rateLimitUntil);
                if (stillActive) {
                    this.rateLimitUntil = rateLimitUntil;
                } else {
                    localStorage.removeItem(rateLimiterLocalStorageKey);
                }
            }
        },
        registerSubmission() {
            const timestamp = Date.now() + 60 * 1000;
            this.rateLimitUntil = timestamp;
            this.input = null;
            localStorage.setItem(rateLimiterLocalStorageKey, `${timestamp}`);
        },
        startGenerationLoader() {
            this.generating = true;
        },
        stopGenerationLoader() {
            this.generating = false;
        },
        async generate() {
            this.startGenerationLoader();
            const livewireManager = useLivewireManager();
            const component = livewireManager.getComponent();
            const result = await component.call('generateCaptcha');
            this.captcha.image = result.image;
            this.captcha.fingerprint = result.fingerprint;
            this.stopGenerationLoader();
        }

    }

})
